import { render, staticRenderFns } from "./GuiasDeCobranca.vue?vue&type=template&id=c94880f4&"
import script from "./GuiasDeCobranca.vue?vue&type=script&lang=js&"
export * from "./GuiasDeCobranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports